import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";

import { Breadcrumb } from "ui/breadcrumbs/breadcrumb";
import { type BreadcrumbsProps } from "ui/breadcrumbs/breadcrumbs.types";
import { useBreadcrumbs } from "ui/breadcrumbs/use-breadcrumbs";

/**
 * MUI's `Breadcrumbs` on Figma's: the `nav` landmark, the list and its `/` separators are MUI's, the
 * spacing and type the theme's `MuiBreadcrumbs` entry.
 */
export const Breadcrumbs = ({ breadcrumbs, ref, ...rest }: BreadcrumbsProps) => {
  const { items } = useBreadcrumbs({ breadcrumbs });

  return (
    <MuiBreadcrumbs aria-label="Breadcrumb" {...rest} ref={ref}>
      {items.map(({ key, ...item }) => (
        <Breadcrumb key={key} {...item} />
      ))}
    </MuiBreadcrumbs>
  );
};
